import { createContext } from 'react'

const TimerContext = createContext(-1)
export default TimerContext